export const mockAds = [
  {
    id: 'ad1',
    title: 'Campanha Verão 2026 - Supermercado Central',
    client: 'Supermercado Central',
    size: 'meia_pagina',
    position: 'página_3',
    status: 'ativo',
    startDate: '2026-04-01',
    endDate: '2026-04-30',
    image: 'https://public.readdy.ai/ai/img_res/4d9f4639879de7ac9a2ba53fa3133281.jpg',
  },
  {
    id: 'ad2',
    title: 'Lançamento Residencial Jardins do Sol',
    client: 'Construtora Horizonte',
    size: 'pagina_inteira',
    position: 'contracapa',
    status: 'ativo',
    startDate: '2026-04-05',
    endDate: '2026-05-05',
    image: 'https://readdy.ai/api/search-image?query=real%20estate%20residential%20launch%20luxury%20apartments%20modern%20building%20advertisement&width=600&height=800&seq=ad2&orientation=portrait',
  },
  {
    id: 'ad3',
    title: 'Promoção Dia das Mães - Joalheria Brilhante',
    client: 'Joalheria Brilhante',
    size: 'quarto_pagina',
    position: 'página_8',
    status: 'pendente',
    startDate: '2026-04-20',
    endDate: '2026-05-12',
    image: 'https://readdy.ai/api/search-image?query=jewelry%20store%20mothers%20day%20promotion%20elegant%20rings%20necklaces%20advertisement&width=400&height=400&seq=ad3&orientation=squarish',
  },
  {
    id: 'ad4',
    title: 'Concessionária AutoMax - Novos Modelos 2026',
    client: 'AutoMax Veículos',
    size: 'meia_pagina',
    position: 'página_12',
    status: 'ativo',
    startDate: '2026-03-15',
    endDate: '2026-04-15',
    image: 'https://readdy.ai/api/search-image?query=car%20dealership%20new%20models%202026%20automobile%20advertisement%20showroom%20luxury%20vehicles&width=600&height=400&seq=ad4&orientation=landscape',
  },
];

export const mockAdSizes = ['quarto_pagina', 'meia_pagina', 'pagina_inteira', 'banner_horizontal', 'coluna'];
